<template>
  <v-dialog v-model="show" width="700" persistent>
    <v-card>
      <v-toolbar class="grey--text text--darken-2">
        <v-toolbar-title>
          <v-icon>mdi-office-building</v-icon>
          <span>Nova Entidade</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon color="grey darken-2">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="max-height: 500px; overflow-y: auto">
        <v-form ref="form" v-model="valid">
          <v-container grid-list-lg>
            <v-layout column class="mb-3">
              <span class="title mb-2">Entidade</span>
              <sub class="mb-2">Os campos obrigatórios estão marcados com *</sub>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="cpfCnpj"
                    append-icon="mdi-magnify"
                    label="CPF/CNPJ *"
                    :loading="isUserTyping"
                    :mask="cpfCnpjMask"
                    :rules="[validationRules.required]"
                    :error="showErrorMessage"
                    @keydown="showErrorMessage = false"
                    @keypress.enter="searchEntityCNPJ(cpfCnpj)"
                    @input="onCpfCnpjInput"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="name"
                    label="Nome *"
                    :rules="[validationRules.required]"
                    :readonly="isEmpty(cpfCnpj)"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="stateRegistration"
                    label="Inscrição Estadual"
                    :readonly="isEmpty(cpfCnpj)"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="fancyName"
                    label="Nome Fantasia"
                    :readonly="isEmpty(cpfCnpj)"
                  />
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout column class="mb-3">
              <span class="title">Responsável pela Entidade</span>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="contactName"
                    label="Nome do Responsável"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="contactCpf"
                    label="CPF"
                    :mask="masks.cpf"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="role"
                    label="Cargo"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="telephone"
                    label="Telefone"
                    :mask="masks.phone"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="email"
                    label="Email"
                  />
                </v-flex>
              </v-layout>
            </v-layout>


            <v-layout column>
              <span class="title">Endereço da Entidade</span>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field
                    v-model="zipCode"
                    label="CEP *"
                    :rules="[validationRules.required]"
                    :mask="masks.postalcode"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="address"
                    label="Endereço *"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="neighborhood"
                    label="Bairro *"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="state"
                    label="Estado *"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="city"
                    label="Cidade *"
                    :rules="[validationRules.required]"
                  />
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-layout justify-center>
        <v-btn @click="close" flat>Cancelar</v-btn>
        <v-tooltip top v-if="!valid">
          <v-btn
            slot="activator"
            @click="save"
            class="white--text"
            color="blue"
            :disabled="!valid"
          >
            Salvar
          </v-btn>
          <span>Favor preencher os campos marcados com *</span>
        </v-tooltip>
        <v-btn
          v-if="valid"
          slot="activator"
          @click="save"
          class="white--text"
          color="blue"
          :disabled="!valid"
        >
          Salvar
        </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import masks from '@/mixins/masks';
import validationRules from '@/mixins/validation-rules';
import entityService from '@/services/EntityService';
import { isEmpty } from 'lodash';
import formatString from 'format-string-by-pattern';

export default {
  name: 'NewEntityDialog',
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    editMode: {
      default: false,
      type: Boolean,
    },
    entityToEdit: {
      default: () => ({}),
      type: Object,
    },
  },
  data() {
    return {
      address: '',
      cpfCnpj: '',
      cpfCnpjTyped: false,
      city: '',
      contactCpf: '',
      contactName: '',
      entitiesFound: [],
      email: '',
      fancyName: '',
      isUserTyping: false,
      masks,
      name: '',
      neighborhood: '',
      responsibleCPF: '',
      responsibleEmail: '',
      responsibleName: '',
      role: '',
      selectedEntity: [],
      state: '',
      stateRegistration: '',
      showErrorMessage: false,
      telephone: '',
      timeout: null,
      valid: false,
      validationRules,
      zipCode: '',
    };
  },
  methods: {
    isEmpty,
    formatString,
    save() {
      const body = {
        entity: {
          address: this.address,
          city: this.city,
          contact_cpf: this.contactCpf,
          contact_name: this.contactName,
          cpf_cnpj: this.cpfCnpj,
          email: this.email,
          fancy_name: this.fancyName,
          name: this.name,
          neighborhood: this.neighborhood,
          role: this.role,
          state: this.state,
          state_registration: this.stateRegistration,
          telephone: this.telephone,
          zip_code: this.zipCode,
        },
      };
      
      this.sendSaveRequest(body);
    },
    sendSaveRequest(body) {
      if (this.editMode) {
        entityService.updateEntity(this.entityToEdit.id, body)
          .then(({ data }) => {
            this.onRequestSuccess('Entidade atualizada com sucesso');
            this.$emit('entityUpdated', data);
          })
          .catch((err) => {
            this.onRequestError(err);
          });
      } else {
        entityService.createEntity(body)
        .then(({ data }) => {
          this.onRequestSuccess('Entidade criada com sucesso');
          this.$emit('entitySaved', data);
        })
        .catch((err) => {
          this.onRequestError(err);
        });
      }
    },
    onRequestSuccess(message) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'success',
        message,
        button: { show: true, text: 'Fechar', message: '' },
        timeout: 6000,
      });
    },
    onRequestError({ response }) {
      this.showErrorMessage = true;
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: response.data.message || response.data[0],
        messageIcon: 'mdi-alert-outline',
      });
    },
    onCpfCnpjInput(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== '') {
        this.cpfCnpjTyped = true;
      }
    },
    searchEntityCNPJ(entity) {
      if (this.editMode && !this.cpfCnpjTyped) return;

      if (this.isCnpjValid) {
        entityService.searchEntityCNPJ(entity)
          .then(({ data }) => {
            this.selectedEntity = data;
            this.fulfillFields(data);
          })
          .catch((err) => {
            this.onRequestError(err);
          });
      }
    },
    fulfillFields(data) {
      this.address = data.logradouro;
      this.city = data.municipio;
      this.email = data.email;
      this.fancyName = data.fantasia;
      this.name = data.nome;
      this.neighborhood = data.bairro;
      this.responsibleEmail = data.responsibleEmail;
      this.responsibleName = data.responsibleName;
      this.role = data.role;
      this.state = data.uf;
      this.telephone = data.telefone;
      this.zipCode = data.cep;
    },
    close() {
      this.$emit('close');
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.cpfCnpjTyped = false;
      this.showErrorMessage = false;
    },
  },
  computed: {
    isCnpjValid() {
      return !isEmpty(this.cpfCnpj) && this.cpfCnpj.length === 14;
    },
    cpfCnpjMask() {
      if (this.cpfCnpj) {
        return this.cpfCnpj.length <= 11 ? '###.###.###-###' : this.masks.cnpj;
      }
      // if (!isEmpty(this.cpfCnpj)) {
      // }
      // return '###.###.###-###';
    },
  },
  watch: {
    cpfCnpj(val) {
      if (this.isCnpjValid) {
        clearTimeout(this.timeout);
        this.isUserTyping = true;
        this.timeout = setTimeout(() => {
          this.isUserTyping = false;
          this.searchEntityCNPJ(val);
        }, 500);
      }
    },
    show(val) {
      if (val) {
        this.$refs.form.resetValidation();
      }
    },
    entityToEdit: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.name = newValue.name;
          this.cpfCnpj = newValue.cpf_cnpj;
          this.fancyName = newValue.fancy_name;
          this.address = newValue.address;
          this.neighborhood = newValue.neighborhood;
          this.city = newValue.city;
          this.state = newValue.state;
          this.zipCode = newValue.zip_code;
          this.contactName = newValue.contact_name;
          this.role = newValue.role;
          this.telephone = newValue.telephone;
          this.email = newValue.email;
          this.contactCpf = newValue.contact_cpf;
          this.stateRegistration = newValue.state_registration;
        }
      }
    },
  },
  beforeDestroy() {
    this.$refs.form.reset();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/folder/new/NewEntityDialog.vue